module.exports = __webpack_public_path__ + "img/42.36aee978.jpg";